<div class="accordion-item-header"
  role="button"
  tabIndex="0"
  [attr.aria-expanded]="opened"
  [attr.aria-label]="title"
  (viUiAccessibleClick)="onToggle($event)"
  [ngClass]="{'start-position': startPosition, 'end-position': endPosition, 'component-header': isComponentHeader}">
  <div class="title">
    <ng-content select="[accordionTitle]"
      *ngIf="isComponentHeader"></ng-content>
    <span *ngIf="title">{{title}}</span>
  </div>
  <i [ngClass]="iconClass">
  </i>
</div>
<ng-container *ngIf="opened">
  <ng-content></ng-content>
</ng-container>